import React, { useEffect, useState } from "react"
import { Col, Row, } from "reactstrap"
import ReactPaginate from "react-paginate"


const VendorMasterLeadTime = ({
    ltime,
    handleClear
}) => {

    const [currentPage, setCurrentPage] = useState(1)

    const [postsPerPage] = useState(10)

    useEffect(() => {
        setCurrentPage(1)
    }, [handleClear])


    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage

    const currentloc = ltime.slice(indexOfFirstPost, indexOfLastPost)//List of Current Page

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };


    return (
        <React.Fragment>
            <Row className='mt-2'>
                <Col sm={12} md={6} className="mb-4-sm">
                    <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px" }} id={"TaxmodeDet"}>
                        <thead className="table-light">
                            <tr>
                                <th>Location</th>
                                <th>Lead Time</th>

                            </tr>
                        </thead>
                        <tbody disabled={true}>
                            {(currentloc || []).map((values, index) => (
                                <tr>
                                    <td>{values.location}</td>
                                    <td>{values.time}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Row className='mt-2'>
                        <Col md="12">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(ltime.length / postsPerPage)}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                forcePage={currentPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>



        </React.Fragment>

    )
}

export default VendorMasterLeadTime